import { ISilderName, ItemRoutesProps } from "./PageRoute";
import DashboardTemplate from "../../Template/DashboardTemplate";
import { Route } from "react-router-dom";
import { findUserPremission } from "../../Pages/Users/Roles/UserSecurityFind";
import { IPermissionActionType } from "../../Pages/Users/Roles/UserPermissionCommonData";
import { SettingsSections } from "../../Services/SettingService";
import { ITypeIIsClientSpecificRoleDataType } from "../../../Context/RoleContext";
import AddOrderEstimateProformaInvoice from "../../Pages/SalesAndPurchase/Order/Add/AddOrderEstimateProformaInvoice";
import ResourceNotFound from "../ResourceNotFound";
import SalesInvoiceTemplate from "../../Template/SalesInvoiceTemplate";
import SalesNestedRoute from "../../Pages/SalesAndPurchase/NestedRoute/SalesNestedRoute";
import AddSalesInvoiceAndPurchaseBill from "../../Pages/SalesAndPurchase/InvoiceAndPurchaseBill/Add/AddSalesInvoiceAndPurchaseBill";
import AddSalesCreditNotesNew from "../../Pages/SalesAndPurchase/CreditAndDebitNote/Add/AddCreditAndDebitNotesNew";
import GroupDetails from "../../Pages/Master/Group/AllDetailsGroupWise/GroupDetails";
import { SearchLedgerByGroupsTypes } from "../../Services/LedgerService";
import LedgerDetails from "../../Pages/Master/Ledger/LedgerDetails";
import AddDeliveryChallan from "../../Pages/SalesAndPurchase/DeliveryChallan/Add/AddDeliveryChallan";
import AddPaymentInNew from "../../Pages/SalesAndPurchase/ReceiptAndPaymentOut/Add/AddPaymentIn";

const SalesRoute = ({ currentClient, clientSpecificRole }: ItemRoutesProps) => {
  return (
    <>
      {/* ----------- Sales Route ----------- */}
      <Route
        key="salesInvoice"
        path={`/${currentClient?.id}/sales/*`}
        // path={"sales/*"}
        element={
          findUserPremission(
            [
              "Voucher.Sales.1.View",
              "Voucher.Sales.2.View",
              "Voucher.Sales.3.View",
              "Voucher.Sales.5.View",
              "Voucher.Sales.4.View",
              "Voucher.Sales.6.View",
              "Master.Ledger.Customer.View",
            ],
            clientSpecificRole(),
            currentClient?.id,
            [
              SettingsSections.Invoice,
              SettingsSections.PInvoice,
              SettingsSections.CrNote,
              SettingsSections.Receipt,
              SettingsSections.Quotation,
              SettingsSections.SOrder,
            ],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            // <AsyncSalesInvoiceTemplate
            <SalesInvoiceTemplate
              // element={<AsyncSalesNestedRoute />}
              element={<SalesNestedRoute />}
              silderName={ISilderName.Sales}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
              ]}
              menuprops={[
                {
                  showData: "Invoices",
                  addButton: "addInvoice",
                },
                {
                  showData: "Proforma Invoices",
                  addButton: "addProformaInvoices",
                },
                {
                  showData: "Credit Notes",
                  addButton: "addCreditNote",
                },
                {
                  showData: "Receipts",
                  addButton: "addPaymentIn",
                },
                {
                  showData: "Estimate",
                  addButton: "addEstimate",
                },
                {
                  showData: "Sales Order",
                  addButton: "addOrder",
                },
                {
                  showData: "Customers",
                  addButton: "customers",
                },
                // {
                //   showData: "Delivery Challan",
                //   addButton: "addDeliveryChallan",
                // },
                // {
                //   showData: "Items",
                //   addButton: "salesItem",
                // },
                // {
                //   showData: "Customers",
                // },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/sales/addInvoice`}
        element={
          findUserPremission(
            ["Voucher.Sales.1.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Invoice],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesInvoiceAndPurchaseBill />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Invoices",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/sales/editInvoice/:updateId`}
        element={
          findUserPremission(
            ["Voucher.Sales.1.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Invoice],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesInvoiceAndPurchaseBill />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Invoices",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Edit",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/sales/cloneInvoice/:cloneId`}
        element={
          findUserPremission(
            ["Voucher.Sales.1.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Invoice],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesInvoiceAndPurchaseBill />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Invoices",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Clone",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/sales/editInvoiceDraft/:draftId`}
        element={
          findUserPremission(
            ["Voucher.Sales.1.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Invoice],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesInvoiceAndPurchaseBill />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Invoices",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Draft",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* Add sales invoice to sales order  */}
      <Route
        path={`${currentClient?.id}/sales/addInvoice/order/:salesOrderId`}
        element={
          findUserPremission(
            ["Voucher.Sales.1.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Invoice],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesInvoiceAndPurchaseBill />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Invoices",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "SalesOrder",
                  path: `/books/clients/${currentClient?.id}/sales/order`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* Add sales invoice to estimate  */}
      <Route
        path={`${currentClient?.id}/sales/addInvoice/estimate/:quotationId`}
        element={
          findUserPremission(
            ["Voucher.Sales.1.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Invoice],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesInvoiceAndPurchaseBill />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Invoices",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Estimate",
                  path: `/books/clients/${currentClient?.id}/sales/estimate`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* Add sales invoice to proforma invoice  */}
      <Route
        path={`${currentClient?.id}/sales/addInvoice/proformaInvoice/:proformaInvoiceId`}
        element={
          findUserPremission(
            ["Voucher.Sales.1.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Invoice],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesInvoiceAndPurchaseBill />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Invoices",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Proforma Invoices",
                  path: `/books/clients/${currentClient?.id}/sales/proformaInvoices`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/* ----------- Proforma Invoice Route ----------- */}
      <Route
        path={`${currentClient?.id}/sales/addProformaInvoice`}
        element={
          findUserPremission(
            ["Voucher.Sales.2.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.PInvoice],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddOrderEstimateProformaInvoice />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Proforma Invoices",
                  path: `/books/clients/${currentClient?.id}/sales/proformaInvoices`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/sales/editProformaInvoice/:id`}
        element={
          findUserPremission(
            ["Voucher.Sales.2.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.PInvoice],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddOrderEstimateProformaInvoice />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Proforma Invoices",
                  path: `/books/clients/${currentClient?.id}/sales/proformaInvoices`,
                },
                {
                  item: "Edit",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/sales/editProformaInvoiceDraft/:draftId`}
        element={
          findUserPremission(
            ["Voucher.Sales.2.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.PInvoice],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddOrderEstimateProformaInvoice />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Proforma Invoices",
                  path: `/books/clients/${currentClient?.id}/sales/proformaInvoices`,
                },
                {
                  item: "Edit",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/* ----------- Credit Note ----------- */}
      <Route
        path={`${currentClient?.id}/sales/addCreditNote`}
        element={
          findUserPremission(
            ["Voucher.Sales.3.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.CrNote],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesCreditNotesNew />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Credit Note",
                  path: `/books/clients/${currentClient?.id}/sales/creditNotes`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/sales/editCreditNote/:creditNoteId`}
        element={
          findUserPremission(
            ["Voucher.Sales.3.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.CrNote],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesCreditNotesNew />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "CreditNotes",
                  path: `/books/clients/${currentClient?.id}/sales/creditNotes`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/sales/editCreditNoteDraft/:draftId`}
        element={
          findUserPremission(
            ["Voucher.Sales.3.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.CrNote],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesCreditNotesNew />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "CreditNotes",
                  path: `/books/clients/${currentClient?.id}/sales/creditNotes`,
                },
                {
                  item: "Draft",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/*----------- Receipts Route ----------- */}
      <Route
        path={`${currentClient?.id}/sales/addReceipt`}
        element={
          findUserPremission(
            ["Voucher.Sales.5.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Receipt],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddPaymentInNew />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Receipts",
                  path: `/books/clients/${currentClient?.id}/sales/receipts`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/sales/editReceipt/:paymentId`}
        element={
          findUserPremission(
            ["Voucher.Sales.5.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Receipt],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddPaymentInNew />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Receipts",
                  path: `/books/clients/${currentClient?.id}/sales/receipts`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/sales/editReceiptDraft/:draftId`}
        element={
          findUserPremission(
            ["Voucher.Sales.5.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Receipt],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddPaymentInNew />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Receipt",
                  path: `/books/clients/${currentClient?.id}/sales/receipts`,
                },
                {
                  item: "Draft",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/*----------- Estimate Route -----------*/}
      <Route
        path={`${currentClient?.id}/sales/addEstimate`}
        element={
          findUserPremission(
            ["Voucher.Sales.4.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Quotation],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddOrderEstimateProformaInvoice />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Estimate",
                  path: `/books/clients/${currentClient?.id}/sales/estimate`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/sales/editEstimate/:id`}
        element={
          findUserPremission(
            ["Voucher.Sales.4.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Quotation],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddOrderEstimateProformaInvoice />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Estimate",
                  path: `/books/clients/${currentClient?.id}/sales/estimate`,
                },
                {
                  item: "Edit",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/sales/editEstimateDraft/:draftId`}
        element={
          findUserPremission(
            ["Voucher.Sales.4.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.Quotation],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddOrderEstimateProformaInvoice />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Estimate",
                  path: `/books/clients/${currentClient?.id}/sales/estimate`,
                },
                {
                  item: "Draft",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* Add Estimate to sales order sales/addSalesOrder/estimate */}
      <Route
        path={`${currentClient?.id}/sales/addSalesOrder/estimate/:estimateId`}
        element={
          findUserPremission(
            ["Voucher.Sales.6.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.SOrder],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddOrderEstimateProformaInvoice />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Order",
                  path: `/books/clients/${currentClient?.id}/sales/order`,
                },
                {
                  item: "Estimate",
                  path: `/books/clients/${currentClient?.id}/sales/estimate`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/* ----------------------- Sales Order ------------------------ */}
      <Route
        path={`${currentClient?.id}/sales/addOrder`}
        element={
          findUserPremission(
            ["Voucher.Sales.6.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.SOrder],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddOrderEstimateProformaInvoice />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Order",
                  path: `/books/clients/${currentClient?.id}/sales/order`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/sales/editSalesOrder/:id`}
        element={
          findUserPremission(
            ["Voucher.Sales.6.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.SOrder],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddOrderEstimateProformaInvoice />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "SalesOrder",
                  path: `/books/clients/${currentClient?.id}/sales/order`,
                },
                {
                  item: "Edit",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/sales/editSalesOrderDraft/:draftId`}
        element={
          findUserPremission(
            ["Voucher.Sales.6.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.SOrder],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddOrderEstimateProformaInvoice />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "SalesOrder",
                  path: `/books/clients/${currentClient?.id}/sales/order`,
                },
                {
                  item: "Draft",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/*------------------------ Delivery Challan route ------------------------ */}
      <Route
        path={`${currentClient?.id}/sales/addDeliveryChallan`}
        element={
          findUserPremission(
            ["Voucher.Sales.DeliveryChallan.Add"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.DChallan],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddDeliveryChallan />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Delivery Challan",
                  path: `/books/clients/${currentClient?.id}/sales/deliveryChallan`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/sales/editDeliveryChallan/:id`}
        element={
          findUserPremission(
            ["Voucher.Sales.DeliveryChallan.Edit"],
            clientSpecificRole(),
            currentClient?.id,
            [SettingsSections.DChallan],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddDeliveryChallan />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "DeliveryChallan",
                  path: `/books/clients/${currentClient?.id}/sales/addDeliveryChallan`,
                },
                {
                  item: "Edit",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/* ----------- Party Details Sales Route ----------- */}
      <Route
        path={`${currentClient?.id}/sales/addInvoice/:partyId`}
        element={
          findUserPremission(
            [
              "Voucher.Sales.1.Edit",
              // "Voucher.Sales.2.Edit",
              // "Voucher.Sales.3.Edit",
              // "Voucher.Sales.5.Edit",
              // "Voucher.Sales.4.Edit",
              // "Voucher.Sales.6.Edit",
              // "Master.Ledger.Customer.Edit",
            ],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.Invoice],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesInvoiceAndPurchaseBill />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Invoices",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Parties",
                  path: `/books/clients/${currentClient?.id}/parties`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      <Route
        path={`${currentClient?.id}/sales/addCreditNote/:partyId`}
        element={
          findUserPremission(
            ["Voucher.Sales.3.Edit"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.CrNote],
            {
              actionType: IPermissionActionType.Edit,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) ? (
            <DashboardTemplate
              element={<AddSalesCreditNotesNew />}
              breadcrumprops={[
                {
                  item: "Sales",
                  path: `/books/clients/${currentClient?.id}/sales/invoices`,
                },
                {
                  item: "Credit Note",
                  path: `/books/clients/${currentClient?.id}/sales/creditNotes`,
                },
                {
                  item: "Parties",
                  path: `/books/clients/${currentClient?.id}/parties`,
                },
                {
                  item: "Add",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />

      {/* Customer Inside Details Routes */}
      <Route
        path={`/${currentClient?.id}/sales/customerLedger/:ledgerId`}
        element={
          <DashboardTemplate
            element={
              <LedgerDetails
                searchLedgerByGroupsTypes={
                  SearchLedgerByGroupsTypes.DebtorsOnly
                }
                showName="Customer"
              />
            }
            breadcrumprops={[
              {
                item: "Sales",
                path: `/books/clients/${currentClient?.id}/sales/invoices`,
              },
              {
                item: "Customers",
                path: `/books/clients/${currentClient?.id}/sales/customers`,
              },
              {
                item: "Ledger",
              },
            ]}
          />
        }
      />
      <Route
        path={`/${currentClient?.id}/sales/customerGroup/:groupId`}
        element={
          <DashboardTemplate
            element={
              <GroupDetails
                searchLedgerByGroupsTypes={
                  SearchLedgerByGroupsTypes.DebtorsOnly
                }
                showName="Income"
              />
            }
            breadcrumprops={[
              {
                item: "Sales",
                path: `/books/clients/${currentClient?.id}/sales/invoices`,
              },
              {
                item: "Customers",
                path: `/books/clients/${currentClient?.id}/sales/customers`,
              },
              {
                item: "Group",
              },
            ]}
          />
        }
      />
    </>
  );
};

export default SalesRoute;
